import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import TariffDetails from '../TariffDetails/TariffDetails';

export default function initTariffDetails() {

  const products = window.digitalData.products || [];
  const tariffDetailsWrapper = document.querySelectorAll('[data-component="tariff-info"]');

  [...tariffDetailsWrapper].forEach((mountEl) => {
    const productId = mountEl.getAttribute('data-productid');
    const currentProduct = products.filter(
      (product) => product.productID === productId
    ).shift();

    if (!tariffDetailsWrapper) {
      return;
    }

    if (tariffDetailsWrapper) {
      ReactDOM.render(
        <Provider store={window.appState}>
          <TariffDetails details={currentProduct.tariffDetails} />
        </Provider>, mountEl
      );
    }
  });
}
